var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.4375C14.4876 0.443413 9.68212 2.43722 6.13779 5.98154C2.59346 9.52587 0.599661 14.3313 0.593747 19.3438C0.587744 23.4399 1.92575 27.4249 4.4025 30.6875C4.4025 30.6875 4.91812 31.3664 5.00234 31.4644L19.5 48.5625L34.0045 31.4558C34.0802 31.3647 34.5975 30.6875 34.5975 30.6875L34.5992 30.6823C37.0747 27.4212 38.4121 23.438 38.4062 19.3438C38.4003 14.3313 36.4065 9.52587 32.8622 5.98154C29.3179 2.43722 24.5124 0.443413 19.5 0.4375ZM19.5 26.2188C18.1403 26.2188 16.811 25.8155 15.6805 25.0601C14.5499 24.3047 13.6687 23.2309 13.1483 21.9747C12.628 20.7185 12.4918 19.3361 12.7571 18.0025C13.0224 16.6689 13.6772 15.4439 14.6386 14.4824C15.6001 13.5209 16.8251 12.8661 18.1588 12.6009C19.4924 12.3356 20.8747 12.4717 22.1309 12.9921C23.3872 13.5124 24.4609 14.3936 25.2164 15.5242C25.9718 16.6548 26.375 17.984 26.375 19.3438C26.3727 21.1664 25.6477 22.9138 24.3588 24.2026C23.07 25.4914 21.3227 26.2165 19.5 26.2188Z",
    fill: "#FF7C33"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.3c1d1623.svg";
export { ForwardRef as ReactComponent };